module.exports = __webpack_public_path__ + "static/media/Ecdclogo_nobg.660ae210.svg";